module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_9006.0a97fc71.png";